export default __webpack_public_path__ + "static/media/greenRight.bd8f7dc3.svg";